<template>
  <v-container class="py-10 mb-10" id="inhalte">
    <v-row class="align-center">
      <v-col cols="12" lg="6" class="pr-10">
        <h2>64. Inhalte</h2>
        <p style="color: green">
          <b>UPDATE</b>
        </p>
        <v-menu offset-y>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on" aria-hidden="true">
              <v-icon>mdi-download</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="download('image/jpeg')">
              <v-list-item-content>
                <v-list-item-title>JPEG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item @click="download('image/svg+xml')">
              <v-list-item-content>
                <v-list-item-title>SVG herunterladen</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-list-item
              href="https://www.hausdesstiftens.org/rechtliches/nutzungsbedingungen/"
              target="blank"
            >
              <v-list-item-content>
                <v-list-item-title class="pb-2" style="color: #7D9B38"
                  >Lizenzbedingungen</v-list-item-title
                >
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-col>
      <v-col cols="12" lg="6">
        <highcharts :options="chartOptions" ref="chart"></highcharts>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "A064",
  data: () => ({}),
  computed: {
    chartOptions() {
      return {
        chart: {
          type: "column"
        },
        title: {
          text:
            "Welchen Content verbreitet Ihre Organisation über Social Media?"
        },
        xAxis: {
          categories: [
            "Events und Termine",
            "Neuigkeiten über unsere Organisation",
            "Nachberichte und Rückblicke",
            "Fragen, Diskussion und Dialog mit Zielgruppen",
            "Thematische Dokumentation",
            "Interaktive Inhalte"
          ],
          visible: true
        },
        yAxis: {
          min: 0,
          max: 100,
          title: {
            text: "Prozent der Organisationen"
          }
        },
        tooltip: {
          headerFormat:
            '<span style="font-size:12px">{point.key}</span><table>',
          pointFormat:
            '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
            '<td style="padding:0"><b>{point.y:.1f}%</b></td></tr>',
          footerFormat: "</table>",
          shared: true,
          useHTML: true
        },
        series: [
          {
            name: "genannt",
            data: [94.29, 91.92, 71.67, 24.07, 21.18, 11.12],
            showInLegend: false
          }
        ],
        exporting: {
          enabled: false,
          fallbackToExportServer: false,
          filename: "Social_Media_2",
          chartOptions: {
            chart: {
              backgroundColor: "#ffffff"
            },
            credits: {
              enabled: true,
              text:
                "© Digital-Report 2020: Alle Inhalte sind urheberrechtlich geschützt."
            }
          }
        }
      };
    }
  },
  methods: {
    download(type) {
      this.$refs.chart.chart.exportChartLocal({
        type: type
      });
    }
  }
};
</script>
